import classNames from 'classnames'
import React from 'react'
import styles from './styles.module.scss'

type Props = {
  className?: string
  selected?: boolean
  caption: string
  location: string
}

export const Tab: React.FC<Props> = ({ className, caption, selected, location }) => {
  return !selected ? (
    <a href={location} className={classNames(styles.container, className)}>
      {caption}
    </a>
  ) : (
    <div className={classNames(styles.container, className, styles.selected)}>{caption}</div>
  )
}

export default Tab
